import React, { useMemo } from "react";
import DynamicTable from "../../../SharedFiles/CommonTable/dynamicTable";
import {showDeleteConfirmation} from "../../../SharedFiles/WarningMessage/deleteWarning";
const DeliveryTable = ({header,tablebody,onEdit,
    remainingQty,setRemainingQty,setTableData,pageName}) => {   
        // const onDelete = (action, rowIndex) => {
        //     showDeleteConfirmation(() => {
        //         const rowToDelete = tablebody[rowIndex];
        //         const remaining= remainingQty +rowToDelete.quantity_Nos;
                
        //         setRemainingQty(remaining);
        //       const updatedTableBody = tablebody.filter((_, index) => index !== rowIndex);
        //       setTableData(updatedTableBody);
        //     }); 
        //   };
        const onDelete = (action, rowIndex, row) => {
            const deleteIndex = tablebody.findIndex(
              (r) => r.batch_Number === row.batch_Number
            );    
            showDeleteConfirmation(() => {
              const rowToDelete = tablebody[deleteIndex];
              const remaining = remainingQty + rowToDelete.quantity_Nos;
        
              setRemainingQty(remaining);
              const updatedTableBody = tablebody.filter(
                (_, index) => index !== deleteIndex
              );
              setTableData(updatedTableBody);
            });
          };
          const groupedDataSorted = useMemo(() => {
            const grouped =
              tablebody?.reduce((acc, row) => {
                const key = row.item_Code || "Unassigned";
                if (!acc[key]) acc[key] = [];
                acc[key].push(row);
                return acc;
              }, {}) || {};
        
            const entries = Object.entries(grouped);
        
            // // Move selected batch group to the top
            // if (selectedBatch?.batch_Number) {
            //     const selectedIndex = entries.findIndex(([key]) => key === selectedBatch.batch_Number);
            //     if (selectedIndex > -1) {
            //         const [selectedEntry] = entries.splice(selectedIndex, 1);
            //         entries.unshift(selectedEntry);
            //     }
            // }
            return entries;
          }, [tablebody]);
    return (
        <div>
            {header?.length > 0 &&  
                <DynamicTable
                header={header}
                tablebody={tablebody} 
                onEdit={onEdit}
                groupedDataSorted={groupedDataSorted}
                onDelete={onDelete}
                pageName={pageName}/>}
        </div>
    );
}

export default DeliveryTable;